export const subscriptionClasses = 'relative overflow-hidden flex justify-center';

const footerSubscriptionCommonTheme = {
  subscriptionClasses,
};

export default footerSubscriptionCommonTheme;
